// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalEligibilityLifetime {
    'maximumAmount'?: string;
    'maximumExists'?: boolean | null;
    'maximumMet'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalEligibilityLifetime>> = [
        {
            "name":     "maximumAmount",
            "baseName": "maximumAmount",
            "type":     "string"
        },
        {
            "name":     "maximumExists",
            "baseName": "maximumExists",
            "type":     "boolean"
        },
        {
            "name":     "maximumMet",
            "baseName": "maximumMet",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalEligibilityLifetime.attributeTypeMap;
    }
}
